import { render, staticRenderFns } from "./ForgetSix.vue?vue&type=template&id=487cbaca&scoped=true&"
import script from "./ForgetSix.vue?vue&type=script&lang=js&"
export * from "./ForgetSix.vue?vue&type=script&lang=js&"
import style0 from "./ForgetSix.vue?vue&type=style&index=0&id=487cbaca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487cbaca",
  null
  
)

export default component.exports